import {
  HIDE_LEGAL_ENTITY_LIST_LOADER,
  SET_LEGAL_ENTITY_PROFILE,
  SET_LEGAL_ENTITY_LIST,
  SET_ERROR_LEGAL_ENTITY_PROFILE,
  SHOW_LEGAL_ENTITY_LIST_LOADER,
  LEGAL_ENTITY_PROFILE_LOADER,
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  profileData: {},
  profileLoader: false,
  isError: false,
  loading: false,
  error: null,
};

const LegalEntityList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_LEGAL_ENTITY_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SHOW_LEGAL_ENTITY_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_LEGAL_ENTITY_LIST_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_LEGAL_ENTITY_PROFILE:
      return {
        ...state,
        profileData: action.payload,
      };
    case SET_ERROR_LEGAL_ENTITY_PROFILE:
      return {
        ...state,
        isError: action.payload,
      };
    case LEGAL_ENTITY_PROFILE_LOADER:
      return {
        ...state,
        profileLoader: !state.profileLoader,
      };
    default:
      return state;
  }
};

export default LegalEntityList;
